import React from 'react'
import s from './teacher-reviews.module.scss'
import { IconStarFilled, IconAlertHexagon } from '@tabler/icons-react'
import { Review } from './reviews';

export const TeacherReviews = ({teacher}) => {
	if (!teacher) return null

	const hasReviews = teacher?.reviews?.length > 0

	return (
		<div className={s.wrapper}>
			<div className={s.ratingWrapper}>
					<p className={s.ratingTitle}>Оценка преподавателя</p>
					{hasReviews && (
						<div className={s.ratingNumber}>
							<IconStarFilled color='#FFC035'/>
							{teacher?.rating}
						</div>
					)}
			</div>
			{hasReviews ? (
				<div className={s.reviewsWrapper}>
					{teacher?.reviews?.map(r => <Review key={r.id} review={r}/>)}
				</div>
			) : (
				<div className={s.placeholder}>
					<IconAlertHexagon size={20} className={s.placeholderIcon} />
					<span className={s.placeholderText}>Преподаватель ждет свои первые отзывы</span>
				</div>
			)}
		</div>
	)
}